import { render } from "./Afaire.vue?vue&type=template&id=73a72239&scoped=true"
const script = {}

import "./Afaire.vue?vue&type=style&index=0&id=73a72239&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73a72239"

export default script